import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Scadenza } from 'src/app/common/models/scadenza';
import { CreazionePraticaStoreService } from '../../../../services/creazione-pratica-store.service';
import { TipoScadenza } from 'src/app/common/models/tipologiche/tipo-scadenza';
import { FormGroup } from '@angular/forms';
import { CreazionePraticaTipologicheService } from '../../../../services/creazione-pratica-tipologiche.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { stepMap } from '../../../creazione-pratica-stepper/config/step';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { ConfigurationUtilService } from 'src/app/core/services/configuration-util-service';
import { ScadenzaModListRinviiComponent } from 'src/app/common/components/fascicolo/scadenzario-list-rinvii/scadenza-mod-list-rinvii.component';

@Component({

  selector: 'step-adempimenti-list',
  templateUrl: './step-adempimenti-list.component.html',
  styleUrls: ['./step-adempimenti-list.component.css']
})
export class StepAdempimentiListComponent implements OnInit, OnDestroy {

  @Input() scadenze: Scadenza[] = [];
  @Input() fascicolo;
  @Input() sezione;
  scadenzeFiltrate: Scadenza[] = [];
  tipiScadenze: TipoScadenza[] = [];
  tipiScadenzeTabs: TipoScadenza[] = [{id: 'tutti', descrizione: 'Tutti', label: 'Tutti', rimosso: false}];
  formFiltro: FormGroup;
  currentTab: string = 'tutti';
  activeIndex: number;
  accordions = stepMap;
  writable: boolean;
  filtroStato: string = 'tutti';
  @Output() deleteEvent: EventEmitter<{scadenza: Scadenza, index: number}> = new EventEmitter<{scadenza: Scadenza, index: number}>();
  @Output() onDropDownEvent: EventEmitter<DropDownEvent> = new EventEmitter<DropDownEvent>();
  @Output() editEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() onDocumentEvent: EventEmitter<DocumentEvent> = new EventEmitter<DocumentEvent>();
  @ViewChild('modaleListRinviiScadenza') modaleListRinviiScadenza: ScadenzaModListRinviiComponent;
  private componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private tipologicheService: CreazionePraticaTipologicheService,
    private viewManager: ViewManagerService,
    private configurationUtil: ConfigurationUtilService
  ) {
    creazionePraticaStoreService.scadenze$.pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.scadenze = response;
      this.scadenzeFiltrate = response;
      if(this.scadenze == null) this.scadenze = [];
    });
    this.tipologicheService.getTipiScadenza().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      /*
      LOGICA PER MOSTRARE IL TIPO D'ADEMPIMENTO INCONTRO CGS, REINSTATARE AD IMPLEMENTAZIONE COMPLETA DEL TIPO
      if(this.creazionePraticaStore.getTipoFascicolo() != null && this.creazionePraticaStore.getTipoFascicolo().label != "SINISTRO SANITARIO")
        this.tipiScadenze = response.filter(el => el.id != 'INCONTRO');
      else
        this.tipiScadenze = response;*/
      // this.tipiScadenze = response.filter(el => el.id != 'INCONTRO');
      this.tipiScadenzeTabs = [...this.tipiScadenzeTabs, ...this.tipiScadenze];
    });
    // this.scadenzeFiltrate = this.scadenze;
    this.configurationUtil.descrittoriMap.subscribe(descrittore => {
      if(descrittore) {
        this.writable = descrittore[NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO].writable
      }
    })
  }

  ngOnInit() {
    this.scadenzeFiltrate = this.scadenze;
  }

  ngOnDestroy(){  
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  setTab(tab: string){
    this.filterScadenza(tab);
  }

  openListRinviiModal(scadenza: Scadenza) {
    this.modaleListRinviiScadenza.inizializza(scadenza);
  }

  filterScadenza(filter: string){
    this.activeIndex = undefined;
    this.currentTab = filter;
    if (filter === 'tutti') {
      this.scadenzeFiltrate = this.scadenze.filter(
        (scadenza: Scadenza) => scadenza.tipoScadenza.id !== null
      );
    } else {
      this.scadenzeFiltrate = this.scadenze.filter(
        (scadenza: Scadenza) => scadenza.tipoScadenza.id === filter
      );
    }
  }

  filtraStato(event) {
    switch (event) {
      case 'evase':
        this.scadenzeFiltrate = this.scadenze.filter(
          (el) => el.evasa === true
        );
        break;
      case 'inevase':
        this.scadenzeFiltrate = this.scadenze.filter(
          (el) => !el.evasa && el.giorniRitardo
        );
        break;
      case 'daEvadere':
        this.scadenzeFiltrate = this.scadenze.filter(
          (el) => !el.evasa && !el.giorniRitardo
        );
        break;
      case 'tutti':
        this.scadenzeFiltrate = this.scadenze.filter(
          (scadenza: Scadenza) => scadenza.tipoScadenza.id !== null
        );
        break;
      default:
        break;
    }
  }

  disassocia(opt: {scadenza: Scadenza, index: number}){
    this.deleteEvent.emit(opt);
    // let filtered = this.scadenze.filter(el => el !== scadenza);
    // console.log(filtered);
    // this.filterScadenza(this.currentTab);
    // this.creazionePraticaStoreService.setAdempimenti(filtered);
    // this.creazionePraticaStoreService.save();
  }

  openDetail(scadenza: Scadenza, indice: number) {
    if (this.activeIndex === undefined || this.activeIndex !== indice) {
      this.activeIndex = indice;
    } else {
      this.activeIndex = undefined;
    }
  }

  onClickDropDownEvent(event: DropDownEvent) {
    this.onDropDownEvent.emit(event);
  }

  onEdit(index: number) {
    this.editEvent.emit(index);
  }

  // documento

  onReturnUpdateCallback(event) {
    this.onDocumentEvent.emit(
      {
        documento: event,
        eventType:  'modifica'
      }
    )
  }

  showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'nuova-versione'
      }
    )
  }

  showHistoryModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'storico'
      }
    )
  }

  removeDoc(documento: DocumentoAllegato, entityId: string, sezioneId: string) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        entityId: entityId,
        sezioneId: sezioneId,
        eventType:  'elimina'
      }
    )
  }

  displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'metadati'
      }
    )
  }
  
  truncate(text: string, chars:number) {
    if(!text) return;
    return text.length > chars ? text.slice(0, chars) + " ... " : text;
  }

}

type DropDownEvent = {
  scadenza: Scadenza,
  eventType: 'evadi' | 'allegato' | 'rinvio' | 'elimina' | 'aggiungiEsitoUdienza' | 'modificaDettaglioUdienza' | 'eliminaDettaglioUdienza',
  index: number
}

type DocumentEvent = {
  documento: DocumentoAllegato,
  scadenza?: Scadenza,
  entityId?: string,
  sezioneId?: string,
  eventType: 'nuova-versione' | 'storico' | 'modifica' | 'elimina' | 'metadati'
}

